import { lazy } from "react";
import routes from "./routesConfig/index";
import { getCurrentUser } from "../../../services/commonService";

const Worker = lazy(() => import("../WorkerPage/Worker"));
const WorkerDetails = lazy(() => import("../WorkerPage/worker-detail/WorkerDetail"));
const WorkerDuplicates = lazy(() => import("../WorkerPage/worker-detail/duplicate/DuplicateWorkerTable"));
const staffType = getCurrentUser()?.data?.staff?.staff_type;

const workerRoutes = [
  { path: routes.workers, component: Worker, moduleKey: staffType === 'partner' ? "partner_worker" : "worker", permissionKey: staffType === 'partner' ? "partner_worker_access" : "worker_access" },

  { path: routes.workerDetails, component: WorkerDetails, moduleKey: staffType === 'partner' ? "partner_worker" : "worker", permissionKey: staffType === 'partner' ? "partner_worker_access" : "worker_access" },

  { path: routes.WorkerDuplicates, component: WorkerDuplicates, moduleKey: staffType === 'partner' ? "partner_worker" : "worker", permissionKey: staffType === 'partner' ? "partner_worker_access" : "worker_access" },
];

export default workerRoutes;